import React from 'react';
import { useTranslation } from 'react-i18next';

export const VisibilityBadge = ({ visibility, onClick }) => {
    const { t } = useTranslation();

    if (!visibility || visibility === 'PRIVATE') return null;

    const isTeamClient = visibility === 'TEAM_CLIENT';
    const label = isTeamClient
        ? t('agent_chat.visibility_team_client')
        : t('agent_chat.visibility_team');
    const badgeClass = isTeamClient
        ? 'visibility-badge visibility-badge--team-client'
        : 'visibility-badge visibility-badge--team';

    return (
        <span
            className={`${badgeClass} ${onClick ? 'visibility-badge--clickable' : ''}`}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick ? 0 : undefined}
        >
            <i className="fas fa-users"></i>
            {isTeamClient && <i className="fas fa-globe-americas visibility-badge__overlay-icon"></i>}
            <span>{label}</span>
        </span>
    );
};
